import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import VideoCard from "../../molecules/video-card/videoCard";

// Styles //
import "./whatAreCommunities.scss";

const WhatAreCommunities = (props: ReferenciaContenido) => {
    const { tituloGeneral, redireccionBoton, descripcion } = props;
    return (
        <div className="o-what-is-communities">
            <div className="container">
                <div className="o-what-is-communities__container">
                    <VideoCard
                        title={tituloGeneral}
                        intro={descripcion.json.content[0].content[0].value}
                        videoUrl={redireccionBoton}
                    />
                </div>
            </div>
        </div>
    );
};

export default WhatAreCommunities;
